"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.rawOperationsToOperations = exports.recipientAccount = exports.getRecipientAccount = exports.isAddressValid = exports.isAccountMultiSign = exports.isMemoValid = exports.formatOperation = exports.getAssetCodeIssuer = exports.getOperationType = exports.getReservedBalance = exports.getBalanceId = exports.getAmountValue = exports.getAccountSpendableBalance = exports.STELLAR_BURN_ADDRESS = void 0;
var bignumber_js_1 = require("bignumber.js");
var stellar_sdk_1 = __importDefault(require("stellar-sdk"));
var account_1 = require("../../account");
var cache_1 = require("../../cache");
var api_1 = require("./api");
var currencies_1 = require("../../currencies");
var operation_1 = require("../../operation");
exports.STELLAR_BURN_ADDRESS = "GAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWHF";
var currency = (0, currencies_1.getCryptoCurrencyById)("stellar");
var getMinimumBalance = function (account) {
    return (0, currencies_1.parseCurrencyUnit)(currency.units[0], (0, exports.getReservedBalance)(account).toString());
};
var getAccountSpendableBalance = function (balance, account) { return __awaiter(void 0, void 0, void 0, function () {
    var minimumBalance, recommendedFee;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                minimumBalance = getMinimumBalance(account);
                return [4 /*yield*/, (0, api_1.fetchBaseFee)()];
            case 1:
                recommendedFee = (_a.sent()).recommendedFee;
                return [2 /*return*/, bignumber_js_1.BigNumber.max(balance.minus(minimumBalance).minus(recommendedFee), 0)];
        }
    });
}); };
exports.getAccountSpendableBalance = getAccountSpendableBalance;
var getAmountValue = function (account, transaction, fees) {
    // Asset
    if (transaction.subAccountId) {
        var asset = (0, account_1.findSubAccountById)(account, transaction.subAccountId);
        return transaction.useAllAmount
            ? new bignumber_js_1.BigNumber(asset.spendableBalance)
            : transaction.amount;
    }
    // Native
    return transaction.useAllAmount && transaction.networkInfo
        ? bignumber_js_1.BigNumber.max(account.spendableBalance.minus(fees), 0)
        : transaction.amount;
};
exports.getAmountValue = getAmountValue;
var getBalanceId = function (balance) {
    switch (balance.asset_type) {
        case "native":
            return "native";
        case "liquidity_pool_shares":
            return balance.liquidity_pool_id || null;
        case "credit_alphanum4":
        case "credit_alphanum12":
            return "".concat(balance.asset_code, ":").concat(balance.asset_issuer);
        default:
            return null;
    }
};
exports.getBalanceId = getBalanceId;
var getReservedBalance = function (account) {
    var _a;
    var numOfSponsoringEntries = Number(account.num_sponsoring);
    var numOfSponsoredEntries = Number(account.num_sponsored);
    var nativeAsset = (_a = account.balances) === null || _a === void 0 ? void 0 : _a.find(function (b) { return b.asset_type === "native"; });
    var amountInOffers = new bignumber_js_1.BigNumber((nativeAsset === null || nativeAsset === void 0 ? void 0 : nativeAsset.buying_liabilities) || 0);
    var numOfEntries = new bignumber_js_1.BigNumber(account.subentry_count);
    return new bignumber_js_1.BigNumber(api_1.BASE_RESERVE_MIN_COUNT)
        .plus(numOfEntries)
        .plus(numOfSponsoringEntries)
        .minus(numOfSponsoredEntries)
        .times(api_1.BASE_RESERVE)
        .plus(amountInOffers);
};
exports.getReservedBalance = getReservedBalance;
var getOperationType = function (operation, addr) {
    switch (operation.type) {
        case "create_account":
            return operation.funder === addr ? "OUT" : "IN";
        case "payment":
            if (operation.from === addr && operation.to !== addr) {
                return "OUT";
            }
            return "IN";
        case "path_payment_strict_send":
            if (operation.to === addr)
                return "IN";
            return "OUT";
        case "path_payment_strict_receive":
            return "IN";
        case "change_trust":
            if (new bignumber_js_1.BigNumber(operation.limit).eq(0)) {
                return "OPT_OUT";
            }
            return "OPT_IN";
        default:
            if (operation.source_account === addr) {
                return "OUT";
            }
            return "IN";
    }
};
exports.getOperationType = getOperationType;
var getAssetCodeIssuer = function (tr) {
    if (tr.subAccountId) {
        var assetString = tr.subAccountId.split("+")[1];
        return assetString.split(":");
    }
    return [tr.assetCode || "", tr.assetIssuer || ""];
};
exports.getAssetCodeIssuer = getAssetCodeIssuer;
var getRecipients = function (operation) {
    switch (operation.type) {
        case "create_account":
            return [operation.account];
        case "payment":
            return [operation.to_muxed || operation.to];
        case "path_payment_strict_send":
            return [operation.to];
        default:
            return [];
    }
};
var formatOperation = function (rawOperation, accountId, addr) { return __awaiter(void 0, void 0, void 0, function () {
    var transaction, type, value, recipients, memo, operation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, rawOperation.transaction()];
            case 1:
                transaction = _a.sent();
                type = (0, exports.getOperationType)(rawOperation, addr);
                value = getValue(rawOperation, transaction, type);
                recipients = getRecipients(rawOperation);
                memo = transaction.memo
                    ? transaction.memo_type === "hash" || transaction.memo_type === "return"
                        ? Buffer.from(transaction.memo, "base64").toString("hex")
                        : transaction.memo
                    : null;
                operation = {
                    id: (0, operation_1.encodeOperationId)(accountId, rawOperation.transaction_hash, type),
                    accountId: accountId,
                    fee: new bignumber_js_1.BigNumber(transaction.fee_charged),
                    value: (rawOperation === null || rawOperation === void 0 ? void 0 : rawOperation.asset_code)
                        ? new bignumber_js_1.BigNumber(transaction.fee_charged)
                        : value,
                    // Using type NONE to hide asset operations from the main account (show them
                    // only on sub-account)
                    type: (rawOperation === null || rawOperation === void 0 ? void 0 : rawOperation.asset_code) && !["OPT_IN", "OPT_OUT"].includes(type)
                        ? "NONE"
                        : type,
                    hash: rawOperation.transaction_hash,
                    blockHeight: transaction.ledger_attr,
                    date: new Date(rawOperation.created_at),
                    senders: [rawOperation.source_account],
                    recipients: recipients,
                    transactionSequenceNumber: Number(transaction.source_account_sequence),
                    hasFailed: !rawOperation.transaction_successful,
                    blockHash: null,
                    extra: {
                        pagingToken: rawOperation.paging_token,
                        assetCode: rawOperation === null || rawOperation === void 0 ? void 0 : rawOperation.asset_code,
                        assetIssuer: rawOperation === null || rawOperation === void 0 ? void 0 : rawOperation.asset_issuer,
                        assetAmount: (rawOperation === null || rawOperation === void 0 ? void 0 : rawOperation.asset_code) ? value.toString() : undefined,
                        ledgerOpType: type,
                        memo: memo
                    }
                };
                return [2 /*return*/, operation];
        }
    });
}); };
exports.formatOperation = formatOperation;
var getValue = function (operation, transaction, type) {
    var value = new bignumber_js_1.BigNumber(0);
    if (!operation.transaction_successful) {
        return type === "IN" ? value : new bignumber_js_1.BigNumber(transaction.fee_charged || 0);
    }
    switch (operation.type) {
        case "create_account":
            value = (0, currencies_1.parseCurrencyUnit)(currency.units[0], operation.starting_balance);
            if (type === "OUT") {
                value = value.plus(transaction.fee_charged);
            }
            return value;
        case "payment":
        case "path_payment_strict_send":
        case "path_payment_strict_receive":
            return (0, currencies_1.parseCurrencyUnit)(currency.units[0], operation.amount);
        default:
            return type !== "IN" ? new bignumber_js_1.BigNumber(transaction.fee_charged) : value;
    }
};
var isMemoValid = function (memoType, memoValue) {
    switch (memoType) {
        case "MEMO_TEXT":
            if (memoValue.length > 28) {
                return false;
            }
            break;
        case "MEMO_ID":
            if (new bignumber_js_1.BigNumber(memoValue.toString()).isNaN()) {
                return false;
            }
            break;
        case "MEMO_HASH":
        case "MEMO_RETURN":
            if (!memoValue.length || memoValue.length !== 64) {
                return false;
            }
            break;
    }
    return true;
};
exports.isMemoValid = isMemoValid;
var isAccountMultiSign = function (account) { return __awaiter(void 0, void 0, void 0, function () {
    var signers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, api_1.fetchSigners)(account)];
            case 1:
                signers = _a.sent();
                return [2 /*return*/, signers.length > 1];
        }
    });
}); };
exports.isAccountMultiSign = isAccountMultiSign;
/**
 * Returns true if address is valid, false if it's invalid (can't parse or wrong checksum)
 *
 * @param {*} address
 */
var isAddressValid = function (address) {
    if (!address)
        return false;
    // FIXME Workaround for burn address, see https://ledgerhq.atlassian.net/browse/LIVE-4014
    if (address === exports.STELLAR_BURN_ADDRESS)
        return false;
    try {
        return (stellar_sdk_1["default"].StrKey.isValidEd25519PublicKey(address) ||
            stellar_sdk_1["default"].StrKey.isValidMed25519PublicKey(address));
    }
    catch (err) {
        return false;
    }
};
exports.isAddressValid = isAddressValid;
exports.getRecipientAccount = (0, cache_1.makeLRUCache)(function (_a) {
    var recipient = _a.recipient;
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, exports.recipientAccount)(recipient)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    }); });
}, function (extract) { return extract.recipient; }, {
    max: 300,
    ttl: 5 * 60
} // 5 minutes
);
var recipientAccount = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var accountAddress, isMuxedAccount, muxedAccount, account;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!address) {
                    return [2 /*return*/, null];
                }
                accountAddress = address;
                isMuxedAccount = Boolean(stellar_sdk_1["default"].StrKey.isValidMed25519PublicKey(address));
                if (isMuxedAccount) {
                    muxedAccount = new stellar_sdk_1["default"].MuxedAccount.fromAddress(address, "0");
                    accountAddress = muxedAccount.baseAccount().accountId();
                }
                return [4 /*yield*/, (0, api_1.loadAccount)(accountAddress)];
            case 1:
                account = _a.sent();
                if (!account) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, {
                        id: account.id,
                        isMuxedAccount: isMuxedAccount,
                        assetIds: account.balances.reduce(function (allAssets, balance) {
                            return __spreadArray(__spreadArray([], __read(allAssets), false), [(0, exports.getBalanceId)(balance)], false);
                        }, [])
                    }];
        }
    });
}); };
exports.recipientAccount = recipientAccount;
var rawOperationsToOperations = function (operations, addr, accountId) { return __awaiter(void 0, void 0, void 0, function () {
    var supportedOperationTypes;
    return __generator(this, function (_a) {
        supportedOperationTypes = [
            "create_account",
            "payment",
            "path_payment_strict_send",
            "path_payment_strict_receive",
            "change_trust",
        ];
        return [2 /*return*/, Promise.all(operations
                .filter(function (operation) {
                return (operation.from === addr ||
                    operation.to === addr ||
                    operation.funder === addr ||
                    operation.account === addr ||
                    operation.trustor === addr ||
                    operation.source_account === addr);
            })
                .filter(function (operation) { return supportedOperationTypes.includes(operation.type); })
                .map(function (operation) { return (0, exports.formatOperation)(operation, accountId, addr); }))];
    });
}); };
exports.rawOperationsToOperations = rawOperationsToOperations;
//# sourceMappingURL=logic.js.map